module.exports = __webpack_public_path__ + "static/media/icon_assistant.63d9f568.svg";